import { GET_REPEATER, LIST_REPEATER } from "../actions/types";

const initialState = {
  repeater: null,
  repeaters: {
    count: 0,
    rows: [],
  },
};

const repeaters = (state = initialState, action) => {
  switch (action.type) {
    case GET_REPEATER:
      return {
        ...state,
        repeater: action.payload,
        repeaters: initialState.repeaters,
      };
    case LIST_REPEATER:
      return {
        ...state,
        repeater: initialState.repeater,
        repeaters: action.payload,
      };
    default:
      return state;
  }
};

export default repeaters;
